<template>
  <div class="about">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="550px"
    >
      <v-card :loading="loading">
        <v-app-bar
          color="info"
          dark
        >
          <v-icon>
            mdi-information-outline
          </v-icon>
          <v-spacer/>
          <v-toolbar-title>{{item.ten}}</v-toolbar-title>
          <v-spacer/>
          <v-btn
            icon
            @click="close()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
          <v-container>
            <div class="row">
              <div class="col">
                <v-list>
                  <v-list-item>
                    <v-list-item-content
                      class="d-flex justify-center"
                    >
                      <v-avatar
                        tile
                        size="150"
                      > 
                        <v-img 
                          :src="`${apiBaseUrl}/uploads/${item.logo}`"
                          width="150px"
                          height="150px"
                          lazy-src="@/assets/NoImage.jpg"
                          contain
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="yellow"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">{{item.chu_quan}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Địa chỉ:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.dia_chi}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Điện thoại:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.so_dien_thoai}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Fax:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.fax}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Email:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.email}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Thiết kế bởi:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.thiet_ke}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Giấy phép số:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.so_gp}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Đơn vị cấp:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.nguoi_cap}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Ngày cấp:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.ngay_cap}}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        item: {}
      }
    },
    computed: {
      ...mapState([ 
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.dialog = true;
          this.loading=true;
          axios.get("api/v1/public/systems/1")
            .then(response => {
              this.item = response.data;
              this.loading=false;
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    methods: {
      close() {
        this.dialog = false;
        this.$emit('closed');
      }
    }
  }
</script>